import { z } from 'zod';
import { CommKind } from '../enums.js';
export const communicationInput = z.object({
    projectId: z.string().optional().nullable(),
    clientId: z.string().optional().nullable(),
    kind: z.nativeEnum(CommKind),
    subject: z.string().min(1).max(300),
    body: z.string().max(20000).optional().nullable(),
    fromText: z.string().max(200).optional().nullable(),
    toText: z.string().max(200).optional().nullable(),
    durationMin: z.coerce.number().int().min(0).optional().nullable(),
    tag: z.string().max(60).optional().nullable(),
    occurredAt: z.string().datetime(),
});
//# sourceMappingURL=communication.js.map